import Request from '@/utils/request'

export function normalDayClaim(taskId) {
  return Request({
    url: `/api/v2/app/activity/eidaladha/daily/claim?taskId=${taskId}`,
    method: 'post',
  })
}

export function normalDaySign() {
  return Request({
    url: '/api/v2/app/activity/eidaladha/daily/sign',
    method: 'post',
  })
}

export function normalActBaseInfo() {
  return Request({
    url: '/api/v2/app/activity/eidaladha/home',
    method: 'get',
  })
}

export function normalMilesClaim() {
  return Request({
    url: '/api/v2/app/activity/eidaladha/milestone/claim',
    method: 'post',
  })
}

export function normalActRank() {
  return Request({
    url: '/api/v2/app/activity/eidaladha/rank',
    method: 'get',
  })
}

export function normalActHistory(params) {
  return Request({
    url: '/api/v2/app/activity/eidaladha/wheel/reward/history',
    method: 'get',
    params,
  })
}

export function normalActSpin(params) {
  return Request({
    url: '/api/v2/app/activity/eidaladha/wheel/spin',
    method: 'get',
    params,
  })
}
